import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import Select from '../../engine/SelectEngine';
import { ConditionsQueryBuilderContext } from '../engine/ConditionsQueryBuilderEngine';

const Container = styled.div`
  display: flex;
  align-items: center;

  & > span {
    margin-right: 0.8rem;
  }
`;

const FlaggingQueryBuilderView = props => {
  const { variant } = useContext(ConditionsQueryBuilderContext);

  return (
    <Container>
      <span>{props.sentencePrefix}</span>
      <Select
        variant={variant}
        value={props.flaggedValue}
        onChange={props.onFlaggingChanged}
        data-testid="condition-builder-flagging-select"
        options={[
          {
            text: 'Flagged',
            value: 'flagged',
            'data-testid': 'condition-builder-flagging-flagged'
          },
          {
            text: 'Not flagged',
            value: 'not_flagged',
            'data-testid': 'condition-builder-flagging-not_flagged'
          }
        ]}
      />
    </Container>
  );
};

export default FlaggingQueryBuilderView;
